var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgCircledInfo = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "matrix(1 0 0 -1 1 25)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.096 7.65a.96.96 0 0 1 1.92 0v5.76a.96.96 0 0 1-1.92 0V7.65zM12.056 15.33a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92z"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  stroke: "#FFF",
  strokeWidth: 2,
  transform: "matrix(1 0 0 -1 0 24)"
}))));
export default SvgCircledInfo;